/*
 * Checks if an unnested object is missing any of the keys in a reference (also-
 * unnested) object.  This can be used to ensure that all reuqired query params
 * are present.
 */
export function isMissingRequired(required?: any | null, current?: any | null) {
    if (!current) return true;
    if (!required) return false;
    const requiredKeys = Object.keys(required);

    return requiredKeys.reduce((isMissing, key) => {
        return !current || typeof current[key] === 'undefined' || isMissing;
    }, false);
}
